import { render, staticRenderFns } from "./platformParaDialog.vue?vue&type=template&id=4a54f2a3&scoped=true&"
import script from "./platformParaDialog.vue?vue&type=script&lang=js&"
export * from "./platformParaDialog.vue?vue&type=script&lang=js&"
import style0 from "./platformParaDialog.vue?vue&type=style&index=0&id=4a54f2a3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a54f2a3",
  null
  
)

export default component.exports